import React from 'react';

type Props = {
  adImage?: string | File | null;
  adImageUrl?: string | null;
  autoEnhance?: boolean;
  blurIntensity?: number;
  specialEffect?: string | null;
  useBackgroundOnly?: boolean;
  primaryColor?: string | null;
  styleKey?: string; // used by getImageOverlayStyles caller in parent
  // parent helper may return undefined for some keys
  getImageOverlayStyles?: (k: string) => React.CSSProperties | undefined;
};

const AdVisualBackground: React.FC<Props> = ({ adImage, adImageUrl, autoEnhance, blurIntensity = 6, specialEffect, useBackgroundOnly, primaryColor, styleKey = 'default', getImageOverlayStyles }) => {
  return (
    <div className="absolute inset-0 flex items-center justify-center overflow-hidden rounded-xl">
      {/* Blur background image */}
      {specialEffect === 'blur' && adImage && (
        <div className="absolute inset-0 z-10" style={{
          backgroundImage: `url(${adImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: `blur(${blurIntensity}px) brightness(1.1)`,
          transform: 'scale(1.1)'
        }}></div>
      )}

      {/* Gradient / shadow overlays */}
      {specialEffect === 'gradient' && <div className="absolute inset-0 bg-gradient-to-br from-blue-600/30 via-purple-600/30 to-pink-600/30"></div>}
      {specialEffect === 'shadow' && <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>}

      {/* Standard translucent overlay (non-blur) */}
      {specialEffect !== 'blur' && <div className="absolute inset-0 bg-opacity-30"></div>}

      {/* Blur-specific darker overlay */}
      {specialEffect === 'blur' && <div className="absolute inset-0 bg-black bg-opacity-20"></div>}

      {adImage ? (
        <>
          <img src={adImageUrl || ''} crossOrigin="anonymous" alt="Ad Content" loading="lazy" decoding="async" className="w-full h-full object-cover" style={{ filter: autoEnhance ? 'brightness(1.2) contrast(1.1) saturate(1.1)' : 'none' }} />
          {typeof getImageOverlayStyles === 'function' && <div style={getImageOverlayStyles(styleKey)} />}
        </>
      ) : (
        <div className="w-full h-full" style={ useBackgroundOnly ? { backgroundColor: primaryColor || '#0066FF' } : { backgroundColor: '#FFFFFF' } } />
      )}
    </div>
  );
};

export default AdVisualBackground;
